import { getRouterLocaleInfo } from './getRouterLocaleInfo'
import { getDefaultLocale } from './getDefaultLocale'

export type StoreSwitcherOptions = Record<string, Record<string, string>>

/**
 * Convert StoreCodeMap to a list of options for store/locale switcher:
 * {
 *     <store label>: {
 *          <real locale code>: <router locale (URL sub-path)>,
 *          <real locale code 2>: <router locale (URL sub-path) 2>
 *     },
 *     <store label 2>: {
 *          <real locale code>: <router locale (URL sub-path) 3>
 *     }
 * }
 * Based on this structure, locale options for each store can be shown.
 * The assumption is that each store (shared currency/country) can have several store views (different locales)
 */
export const getStoreSwitcherOptions = (
    defaultLocale?: string
): StoreSwitcherOptions => {
    if (!defaultLocale) {
        defaultLocale = getDefaultLocale()
    }
    const options: StoreSwitcherOptions = {}
    const routerLocaleInfo = getRouterLocaleInfo()
    if (!routerLocaleInfo) {
        return options
    }
    Object.entries(routerLocaleInfo).forEach(
        ([urlPathLocale, { storeCode, locale, storeLabel }]) => {
            // Skip the default locale in the switcher, as it doesn't have a subpath
            // and overlaps with one of the locales that have it
            if (urlPathLocale === defaultLocale) {
                return
            }
            if (!options[storeLabel]) {
                options[storeLabel] = { [locale]: storeCode }
            } else {
                options[storeLabel][locale] = storeCode
            }
        }
    )
    return options
}
